// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2fbU4","title":"InfoRow_title__3xXuP"};